import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {UserRoleModel} from '../../../shared/dto/user-role.model';
import {UserRoleService} from '../../../shared/service/userrole.service';
import {PageService} from '../../../shared/service/page.service';
import {PageDTO} from '../../../shared/dto/page.model';
import {UserPrivilegeService} from '../../../shared/service/user-privilege.service';
import {SectionService} from '../../../shared/service/section.service';
import {SubSectionService} from '../../../shared/service/sub-section.service';
import {SectionDTO} from '../../../shared/dto/section.model';
import {SubSectionDTO} from '../../../shared/dto/sub-section.model';
import swal, {default as Swal} from 'sweetalert2';
import {UserPrivilegeDTO} from '../../../shared/dto/user-privilege.model';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {Router} from '@angular/router';
import {OperationPrivilageModel} from '../../../shared/dto/operation-privilage-model';

@Component({
  selector: 'app-user-privilege',
  templateUrl: './user-privilege.component.html',
  styleUrls: ['./user-privilege.component.scss']
})
export class UserPrivilegeComponent implements OnInit {
  public privilegeForm: FormGroup;
  public userRoles: UserRoleModel [] = [];
  public userPrivilege: UserPrivilegeDTO[] = [];
  public userPrivileges: UserPrivilegeDTO[] = [];
  target = [];
  source: PageDTO[];
  sectionDTO: SectionDTO[];
  subSectionDTO: SubSectionDTO[];
  pages: string[] = [];
  isExist: boolean = false;
  public href: string = "";

  constructor(private userRoleService: UserRoleService,
              private pageService: PageService,
              private userPrivilegeService: UserPrivilegeService,
              private sectionService: SectionService,
              private subSectionService: SubSectionService,
              private tokenStorageService: TokenStorageService,
              private router : Router) { }

  ngOnInit() {
    this.privilegeForm = new FormGroup({
      userRoleCode: new FormControl(null),
      section: new FormControl(null),
      subSection: new FormControl(null),
      page: new FormControl(null),
    });
    this.href = this.router.url;
    this.loadUserRoles();
    this.loadPages();
    this.loadSections();
    this.loadSubSections();
    this.loadUserPriviledges();
  }

  loadUserPriviledges(){
    this.userPrivilegeService.getAllUserPriviledges().subscribe(
      (data: UserPrivilegeDTO[]) => {
        this.userPrivileges = data;
      }
    );
  }

  loadUserRoles() {
    this.userRoleService.getAllUserRoles().subscribe(
      (data: UserRoleModel[]) => {
        this.userRoles = data;
      }
    );
  }

  loadPages() {
    this.pageService.getAllPages().subscribe(
      (data) => {
        this.source = data;
      }
    );
  }

  loadSections(){
    this.sectionService.getAllSections().subscribe(
      (data) => {
        this.sectionDTO = data;
      }
    );
  }

  loadSubSections(){
    this.subSectionService.getAllSubSections().subscribe(
      (data) => {
        this.subSectionDTO = data;
      }
    );
  }

  onSave(){
    console.log(this.userPrivilege);
    let isValid: boolean = true;
    let errorMessage: string = '';

    if (!this.privilegeForm.valid) {
      isValid = false;
      errorMessage = 'Please, Fill the form Data...!'
    }
    if (isValid) {
      swal.fire({
        title: "Are you sure, you want to submit?",
        text: "",
        showCancelButton: true,

        confirmButtonText: "Yes"
      }).then((result)=> {
        if(result.value) {
          this.userPrivilegeService.saveUserPrivilege(this.userPrivilege).subscribe(
            (success) => {
              if (success === true) {
                swal.fire("Success", "Details submitted successfully", "success");
                this.userPrivilege = [];
              }
            },
            (error) => {
              console.log(error);
              swal.fire("Sorry!", "Something went wrong...!", "error");
            },
            () => {
            }
          );
        }
        }, reason => {
        }
      );
    } else{
      swal.fire('Error',errorMessage,'error');
    }
  }

  addAction(){

    this.isExist = false;
    const userRoleCode = this.privilegeForm.value.userRoleCode;
    const section = this.privilegeForm.value.section;
    const subSection = this.privilegeForm.value.subSection;
    for(let entry of this.target) {
      let i;
      for (i = 0; i < this.userPrivilege.length; i++) {
        if (this.privilegeForm.value.userRoleCode === this.userPrivilege[i].userRole && this.privilegeForm.value.section === this.userPrivilege[i].section1 &&
          this.privilegeForm.value.subSection === this.userPrivilege[i].subSection1) {
          swal.fire('Duplicate record','' , 'warning');
          this.isExist = true;
        }
      }
      if( this.privilegeForm.value.userRoleCode === this.userPrivileges[i].userRole  && this.privilegeForm.value.section === this.userPrivileges[i].section1 &&
        this.privilegeForm.value.subSection === this.userPrivileges[i].subSection1){
        swal.fire('Already Granted Permission','' , 'warning');
        this.isExist = true;
      }
    }
      if(!this.isExist) {
        for(let entry of this.target) {
          this.userPrivilege.push(new UserPrivilegeDTO(this.tokenStorageService.getUserObjectToken().username,entry.description,section,subSection,userRoleCode,this.href));
        }
      }

  }

  resetForm(){
    this.privilegeForm.reset();
    this.target = null;
  }

  getCurrentUser(selectedUser: string) {
    this.userPrivilegeService.getByUser(selectedUser)
      .subscribe((result: PageDTO[]) => {
        if (result) {
         this.target = result;
        } else {
          console.log('Error occured...');
        }
      });
  }

}
